import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ReactOnRails from 'react-on-rails';

import ActivityClassificationsApp from './ActivityClassificationsAppClient';
import AdminAccessApp from './AdminAccessAppClient';
import AdminAccountsApp from './AdminAccountsAppClient';
import AdminsEditorApp from './AdminsEditorAppClient';
import AnnouncementsApp from './AnnouncementsAppClient';
import ApApp from './ApAppClient';
import AssignActivitiesApp from './AssignActivitiesAppClient';
import BlogPostsApp from './BlogPostsAppClient';
import CmsActivitiesAppClient from './CmsActivitiesAppClient';
import CmsDistrictIndexApp from './CmsDistrictIndexAppClient';
import CmsSalesmateApp from './CmsSalesmateAppClient';
import CmsSchoolIndexApp from './CmsSchoolIndexAppClient';
import CmsUserIndexApp from './CmsUserIndexAppClient';
import DashboardApp from './DashboardAppClient';
import DemoAccountBanner from './DemoAccountBannerAppClient';
import DiagnosticReportsApp from './DiagnosticReportsAppClient.jsx';
import ExpandableUnitSection from './ExpandableUnitClient';
import ForgotPasswordApp from './ForgotPasswordAppClient';
import LessonPlannerApp from './LessonPlannerAppClient';
import LiveViewApp from './LiveViewAppClient';
import StudentsOnlineNavbarButton from './StudentsOnlineNavbarButtonAppClient';
import ManageActivitiesV2App from './ManageActivitiesV2AppClient';
import PreApApp from './PreApAppClient';
import PremiumHubApp from './PremiumHubAppClient';
import PremiumPricingGuideApp from './PremiumPricingGuideAppClient';
import PressApp from './PressAppClient';
import ProgressReportApp from './ProgressReportAppClient';
import PublicActivityPacksApp from './PublicActivityPacksAppClient.jsx';
import PublicUnitTemplatesApp from './PublicUnitTemplatesAppClient.jsx';
import QuestionsAndAnswersSection from './QuestionsAndAnswersClient';
import ResetPasswordApp from './ResetPasswordAppClient';
import ResultsPageApp from './ResultsPageAppClient';
import SalesFormApp from './SalesFormAppClient';
import ScorebookApp from './ScorebookAppClient';
import SpringBoardApp from './SpringBoardAppClient.tsx';
import SubscriptionApp from './SubscriptionAppClient';
import TeacherAccountApp from './TeacherAccountAppClient';
import TeacherClassroomsApp from './TeacherClassroomsAppClient';
import TeacherFixApp from './TeacherFixAppClient';
import TeacherGuideApp from './TeacherGuideClient';
import TeacherPremiumApp from './TeacherPremiumAppClient';
import TeksPageApp from './TeksPageAppClient';
import TeksGradeLevelPageApp from './TeksGradeLevelPageAppClient';
import TutorialsApp from './TutorialsAppClient';
import UnitTemplateCategoriesApp from './UnitTemplateCategoriesAppClient';
import WorldHistory1200ToPresentApp from './WorldHistory1200ToPresentAppClient';
import WorldHistory1750ToPresentApp from './WorldHistory1750ToPresentAppClient';
import SocialStudiesSubjectPageApp from './SocialStudiesSubjectPageAppClient';
import BuildingAIKnowledgeApp from './BuildingAIKnowledgeAppClient';
import InterdisciplinaryScienceSubjectPageApp from './InterdisciplinaryScienceSubjectPageAppClient';
import LiteratureSubjectPageApp from './LiteratureSubjectPageAppClient';
import LiteratureGradeLevelPageApp from './LiteratureGradeLevelPageAppClient';
import DiagnosticInsightsApp from './DiagnosticInsightsAppClient';
import SkillsReportApp from './SkillsReportAppClient';
import StandardsReportApp from './StandardsReportAppClient';
import ProgressReportsSubnavLinks from './ProgressReportsSubnavLinksAppClient'

import UploadRostersApp from '../../Staff/startup/UploadRostersAppClient';
import StudentFeedbackModal from '../../Student/startup/StudentFeedbackModalAppClient';
import StudentNavbarItems from '../../Student/startup/StudentNavbarItemsAppClient';
import PreNavigationBanner from '../../Shared/components/shared/preNavigationBannerApp';

import '../styles/styles.scss';
import '../../../assets/javascripts/clickHandlers.js'

// This is how react_on_rails can see the TeacherApp in the browser.

ReactOnRails.register({
  TeacherGuideApp,
  DashboardApp,
  LessonPlannerApp,
  LiveViewApp,
  StudentsOnlineNavbarButton,
  ManageActivitiesV2App,
  TeacherAccountApp,
  ScorebookApp,
  PremiumPricingGuideApp,
  ProgressReportApp,
  ResultsPageApp,
  PremiumHubApp,
  AdminAccountsApp,
  AdminsEditorApp,
  PublicActivityPacksApp,
  DiagnosticReportsApp,
  PublicUnitTemplatesApp,
  AssignActivitiesApp,
  TutorialsApp,
  TeacherFixApp,
  ActivityClassificationsApp,
  SubscriptionApp,
  BlogPostsApp,
  PressApp,
  AnnouncementsApp,
  CmsActivitiesAppClient,
  CmsUserIndexApp,
  CmsSalesmateApp,
  CmsSchoolIndexApp,
  CmsDistrictIndexApp,
  ResetPasswordApp,
  ForgotPasswordApp,
  TeacherClassroomsApp,
  UnitTemplateCategoriesApp,
  StudentNavbarItems,
  ExpandableUnitSection,
  QuestionsAndAnswersSection,
  PreApApp,
  ApApp,
  SpringBoardApp,
  StudentFeedbackModal,
  UploadRostersApp,
  SalesFormApp,
  DemoAccountBanner,
  PreNavigationBanner,
  AdminAccessApp,
  WorldHistory1200ToPresentApp,
  WorldHistory1750ToPresentApp,
  SocialStudiesSubjectPageApp,
  TeksPageApp,
  TeksGradeLevelPageApp,
  BuildingAIKnowledgeApp,
  InterdisciplinaryScienceSubjectPageApp,
  LiteratureSubjectPageApp,
  LiteratureGradeLevelPageApp,
  DiagnosticInsightsApp,
  SkillsReportApp,
  StandardsReportApp,
  ProgressReportsSubnavLinks,
  TeacherPremiumApp
});
